import { useMemo } from 'react';
import { ApiClient, EntityCollection } from '../api/content';
import { createPageQuery, unwrap } from './factory';
import { NewsArticle } from './useNewsArticlesQuery';

function getNewsArticleDetails(slug: string) {
  return ApiClient.get<EntityCollection<NewsArticle>>('/news-articles', {
    params: {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: 'deep',
    },
  });
}

export function getNewsArticleDetailsQuery(slug: string) {
  return createPageQuery({
    queryKey: ['news', slug],
    queryFn: unwrap(() => getNewsArticleDetails(slug)),
  });
}

export function useNewsArticleDetailsQuery(slug: string) {
  const { useQuery } = useMemo(() => getNewsArticleDetailsQuery(slug), [slug]);

  return useQuery();
}
